var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,12h3.537l7.645-7.732c.975-.975.975-2.561,0-3.535-.941-.944-2.586-.947-3.537.002l-7.645,7.732v3.533Zm1-3.123l7.354-7.438c.566-.566,1.555-.566,2.121,0,.585.585.585,1.536-.002,2.123l-7.354,7.438h-2.119v-2.123Zm7,9.123v-7.67l-1,1.012v6.658h-9v3c0,1.103-.897,2-2,2s-2-.897-2-2V3c0-.771-.301-1.468-.78-2h11.35l.938-.949c-.166-.029-.334-.051-.508-.051H3C1.346,0,0,1.346,0,3v3h5v15c0,1.654,1.346,3,3,3h13c1.654,0,3-1.346,3-3v-3h-4ZM5,5H1v-2c0-1.103.897-2,2-2s2,.897,2,2v2Zm18,16c0,1.103-.897,2-2,2h-10.766c.476-.531.766-1.232.766-2v-2h12v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScript);
export default __webpack_public_path__ + "static/media/script.3286c8566b96afa1b52154ca441908b4.svg";
export { ForwardRef as ReactComponent };